import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout/Layout';
import { NotificationCenterService } from '../../services/notificationCenter/notificationService';

//Redux
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/index';
import { UserState } from '../../store/reducers/userReducer';
import { PrefState } from '../../store/reducers/prefReducer';

import { MessagesState } from '../../store/reducers/messagesReducer';

import Moment from 'moment';
import LcIconLink from '../../components/Generic/LcIconLink';
import LcInfiniteTable from "../../components/Data/LcInfiniteTable";

const NotificationCenter: React.FC = (props) => {

  const dispatch = useDispatch();

  const user = useSelector<RootState, UserState>(state => state.user);
  const pref = useSelector<RootState, PrefState>(state => state.pref);
  const msgs = useSelector<RootState, MessagesState>(state => state.msgs);

  const email: string = user.email != undefined ? user.email : '';

  const history = useHistory();

  const [notificationViewResponses, setNotificationViewResponses] = useState<any[]>([]);
  const [notificationViewResponsesFiltered, setNotificationViewResponsesFiltered] = useState<any[]>([]);
  const [visibleNotification, setVisibleNotification] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState<{ size: number, term: string, column: string, direction: string }>({ size: 20, term: "", column: "", direction: "asc" });

  const service = new NotificationCenterService(props);

  const GetNofificationAddRedux = () => {
    service.GetNotifications()
      .then(response => {
        setNotificationViewResponses(response);
        setNotificationViewResponsesFiltered(response);
        dispatch({ type: 'MSG_UPDATE', payload: response || [] });
        dispatch({ type: 'MSG_UPDATE_LAST_TIME', payload: new Date().toISOString() });
      }).catch(error => {
        console.warn(error);
      }).then(() => {
        setIsLoading(false);
      });
  }


  const loadNotifications = () => {
    setIsLoading(true);
    if (msgs.messages.length > 0 && msgs.lastUpdate != '') {
      setNotificationViewResponses(msgs.messages);
      setNotificationViewResponsesFiltered(msgs.messages);
      setIsLoading(false);
      return;
    }
  }

  useEffect(() => {
    loadNotifications();
  }, [msgs.messages, msgs.lastUpdate])

  const goToNotification = (row: any) => {
    deleteNotification(row);
    history.push('SaaS/ResumoSaas');
  }

  const deleteNotification = (row: any) => {
    row.isRead = true;
    service.PostNotifications(row)
      .then(response => {
        GetNofificationAddRedux();
      })
      .catch(error => {
        console.warn(error);
      })
  }

  useEffect(() => {
    var filtered = notificationViewResponses.filter((p: any) =>
      filter.term == '' ||
      p.subject.toLowerCase().indexOf(filter.term) > -1 ||
      p.content.toLowerCase().indexOf(filter.term) > -1 ||
      Moment(p.notificationDateTime).format('DD/MM/YYYY').toLowerCase().indexOf(filter.term) > -1
    )
      .sort((a: any, b: any) => {
        if (filter.direction == 'asc') return (a[filter.column] > b[filter.column]) ? 1 : -1;
        else return (a[filter.column] > b[filter.column]) ? -1 : 1;
      });

    setNotificationViewResponsesFiltered(filtered);
    setVisibleNotification(filtered.slice(0, filter.size));
  }, [filter, notificationViewResponsesFiltered.length > 0]);

  const columns = [
    {
      field: 'subject', headerName: 'Título', width: "30%",
      renderCell: (row: any) => {
        return <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.subject}</div>;
      }
    },
    {
      field: 'content', headerName: 'Mensagem', width: "50%",
      renderCell: (row: any) => {
        return <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.content}</div>;
      }
    },
    {
      field: 'notificationDateTime', headerName: 'Data', width: "10%",
      renderCell: (row: any) => {
        const date = new Date(row.notificationDateTime);
        return <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{date.toLocaleDateString()}</div>;
      }
    },
    {
      field: 'isRead', sort: true, width: "5%",
      renderCell: (row: any) => {
        if (!row.isRead) return <LcIconLink icon="lci lci-eye" tooltip="Marcar como lido" color='#BEBEBE' onClick={() => { deleteNotification(row) }} />
        else return <span></span>
      }
    }
  ];


  const onSortChange = (sortData: any) => {
    const { sort, size } = sortData;
    setFilter({ ...filter, column: sort.column, direction: sort.direction, size: size })
  };

  const loadMore = (size?: number) => {
    if (size) setVisibleNotification(notificationViewResponsesFiltered.slice(0, size))
    else {
      setVisibleNotification([...visibleNotification, ...notificationViewResponsesFiltered.slice(visibleNotification.length, visibleNotification.length + 10)])
    }
  };

  const changeDensity = (density: string) => {
    dispatch({ type: 'PREF_UPDATE', payload: { name: "density", value: density } });
  }
  const [filterVisible, setFilterVisible] = useState(false);
  const filterAdvanced = {
    fields: [{ label: 'Assunto', name: 'assunto', type: 'text' }],
    onChange: (_filter: any, size: number) => setFilter({ ...filter, size: size, term: _filter[0].value.toLowerCase() }),
    visible: filterVisible,
    onChangeVisibility: () => setFilterVisible(!filterVisible)
  };

  return (
    <Layout
      pageTitle="Notificação de sistema"
      dots={
        <>
          <div className='item' style={{ color: pref.data?.density == "high" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("high")}><i className='ppi ppi-view-list' /> Densidade alta</div>
          <div className='item' style={{ color: pref.data?.density == "medium" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("medium")}><i className='ppi ppi-menu' /> Densidade média</div>
          <div className='item' style={{ color: pref.data?.density == "low" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("low")}><i className='ppi ppi-menu-alt-4' /> Densidade baixa</div>
        </>
      }
      gridFilter={{
        toggleVisibility: () => {
          setFilterVisible(!filterVisible)
        },
        size: notificationViewResponsesFiltered.length
      }}
    >
      <LcInfiniteTable
        loading={isLoading}
        columns={columns}
        rows={visibleNotification}
        filter={filterAdvanced}
        size={notificationViewResponsesFiltered.length}
        loadMore={loadMore}
        onSortChange={onSortChange}
        functionsRow={[
          { label: "Navegar", func: goToNotification },
          { label: "Marcar como lida", func: deleteNotification }
        ]}
        density={pref.data?.density || "medium"}
      />
    </Layout>
  );
}

export default NotificationCenter;